import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import type { CampaignInfluencer } from "../types";

interface DeleteInfluencerDialogProps {
  isOpen: boolean;
  influencer: CampaignInfluencer | null;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
}

export const DeleteInfluencerDialog: React.FC<DeleteInfluencerDialogProps> = ({
  isOpen,
  influencer,
  onClose,
  onConfirm,
  isPending,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Remove Influencer</DialogTitle>
          <DialogDescription>
            Are you sure you want to remove {influencer?.name} from this campaign?
            This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending ? "Removing..." : "Remove Influencer"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
